import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { DeviceCardProps } from './types';
import { LABELS } from './constants';
import {
  StyledDeviceCard,
  DeviceCardContent,
  DeviceCardHeader,
  DeviceCardInfo,
  DeviceCardTitle,
  DeviceCardIdentifier,
  DeviceTypeBadge,
  DeviceCardDivider,
  DeviceCardActions,
  ActionIconButton,
} from './styles';

export const DeviceCard: React.FC<DeviceCardProps> = ({
  device,
  isDark,
  onEdit,
  onDelete,
}) => {
  const deviceTypeName = typeof device.type === 'object' ? device.type?.name : 'Unknown';

  return (
    <StyledDeviceCard $isDark={isDark}>
      <DeviceCardContent>
        <DeviceCardHeader>
          <DeviceCardInfo>
            <DeviceCardTitle $isDark={isDark}>
              {device.name}
            </DeviceCardTitle>
            <DeviceCardIdentifier $isDark={isDark}>
              {device.identifier}
            </DeviceCardIdentifier>
          </DeviceCardInfo>
          <DeviceTypeBadge $isDark={isDark}>
            {deviceTypeName}
          </DeviceTypeBadge>
        </DeviceCardHeader>

        <DeviceCardDivider $isDark={isDark} />

        <DeviceCardActions>
          <Tooltip title={LABELS.EDIT_DEVICE}>
            <ActionIconButton
              $isDark={isDark}
              iconColor="#2D6CCA"
              onClick={() => onEdit(device)}
            >
              <FontAwesomeIcon icon={faPen} fontSize={14} color={isDark ? '#fff' : '#222222'} />
            </ActionIconButton>
          </Tooltip>
          <Tooltip title={LABELS.DELETE_DEVICE}>
            <ActionIconButton
              $isDark={isDark}
              iconColor="#f5222d"
              onClick={() => onDelete(device.id)}
            >
              <FontAwesomeIcon icon={faTrash} fontSize={14} color={isDark ? '#fff' : '#222222'} />
            </ActionIconButton>
          </Tooltip>
        </DeviceCardActions>
      </DeviceCardContent>
    </StyledDeviceCard>
  );
};
